import { render, staticRenderFns } from "./DropdownFilters.vue?vue&type=template&id=b09060ba"
import script from "./DropdownFilters.vue?vue&type=script&lang=js"
export * from "./DropdownFilters.vue?vue&type=script&lang=js"
import style0 from "./DropdownFilters.vue?vue&type=style&index=0&id=b09060ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports